import { type IErrorData, getErrorData } from '@/utils/getErrorData';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { getReviews, updateReviewStatus } from '@/api/reviewApi';
import {
  type IReviewFeedbackItem,
  type IReviewFeedbackListResponse,
  type IGetReviewFeedbackParams
} from '@/types/IReviewFeedback';

export const getReviewsThunk = createAsyncThunk<
  IReviewFeedbackListResponse,
  IGetReviewFeedbackParams,
  { rejectValue: IErrorData }
>('reviews/getReviewsThunk', async (params, { rejectWithValue }) => {
  try {
    const data = await getReviews(params);

    if (data.response === null) {
      return rejectWithValue({ message: 'Некорректный ответ сервера' });
    }

    return data.response;
  } catch (error) {
    return rejectWithValue(getErrorData(error));
  }
});

export const updateReviewStatusThunk = createAsyncThunk<
  IReviewFeedbackItem,
  { feedbackId: string; published: boolean },
  { rejectValue: IErrorData }
>(
  'reviews/updateReviewStatusThunk',
  async ({ feedbackId, published }, { rejectWithValue }) => {
    try {
      const data = await updateReviewStatus(feedbackId, published);

      if (data.response === null) {
        return rejectWithValue({ message: 'Некорректный ответ сервера' });
      }

      return data.response;
    } catch (error) {
      return rejectWithValue(getErrorData(error));
    }
  }
);

// TODO: комментарии к отзывам не реализованы на 15.04.2026
// export const updateReviewCommentStatusThunk = createAsyncThunk(...)
// export const createReviewCommentThunk = createAsyncThunk(...)
// export const createReviewCommentReplyThunk = createAsyncThunk(...)
